export const REDUCER_NAME = "nationalTeamCompetitionResults";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONMATCHES = `${REDUCER_NAME}/SET_COMPETITIONMATCHES`;
export const RESET_COMPETITIONMATCHES = `${REDUCER_NAME}/RESET_COMPETITIONMATCHES`;

export const getKey = (data) =>
  `${data.nationalTeamId}_${data.competitionId}_${data.type}`;
